import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import api from './api'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		app, api
	},
	getters
})

export default store
